<template>
  <form class="login-form"
        @submit.prevent="submit">
    <b-alert :show="hasError"
             variant="danger"
             class="alert">
      {{ errorMessage }}
    </b-alert>

    <div class="form-group">
      <input v-model="email"
             class="form-control"
             type="email"
             name="email"
             placeholder="Email address"
             aria-label="Email address">

      <span v-if="showValidation && !email"
            class="validation-error">
        Please enter a valid email address.
      </span>
    </div>

    <div class="form-group">
      <input v-model="password"
             class="form-control"
             type="password"
             name="password"
             placeholder="Password"
             aria-label="Password"
             @focus="isFocused = true"
             @blur="isFocused = false">

      <span v-if="capsLockOn && isFocused"
            class="capslock-warning">
        Caps lock is on.
      </span>

      <span v-if="showValidation && !password"
            class="validation-error">
        Please enter your password.
      </span>
    </div>

    <button class="btn btn-accent-6 btn-rounded"
            aria-label="Login">
      <template v-if="submitting">
        <span class="visually-hidden">
          Loading...
        </span>
        <font-awesome-icon icon="spinner"
                           spin></font-awesome-icon>
      </template>
      <template v-else-if="submitted">
        <span class="visually-hidden">
          Submitted
        </span>
        <font-awesome-icon icon="check"></font-awesome-icon>
      </template>
      <template v-else>
        Login
      </template>
    </button>

    <slot name="forgot-password"
          :getPasswordResetLink="getPasswordResetLink">
    </slot>
  </form>
</template>

<script>
import { login } from "~/Scripts/resources/webAccountResource";

export default {
  name: "LoginForm",
  props: {
    redirect: {
      type: Boolean,
      default: false
    },
    redirectUrl: {
      type: String,
      default: "/"
    }
  },
  data: () => ( {
    email: null,
    password: null,
    showValidation: false,
    hasError: false,
    errorMessage: null,
    capsLockOn: false,
    isFocused: false,
    listener: null,
    submitted: false,
    submitting: false
  } ),
  computed: {
    isValid () {
      let result = false;

      if ( this.email && this.password ) {
        result = true;
      }

      return result;
    }
  },
  mounted () {
    this.listener = document.addEventListener( "keydown", e => {
      if ( e.getModifierState ) {
        this.capsLockOn = e.getModifierState( "CapsLock" );
      }
    } );
  },
  destroyed () {
    document.removeEventListener( "keydown", this.listener );
    this.listener = null;
  },
  methods: {
    getPasswordResetLink ( base ) {
      let result = base;

      if ( this.email ) {
        result += `?email=${this.email}`;
      }

      return result;
    },
    submit () {
      this.showValidation = true;

      if ( this.isValid ) {
        this.submitting = true;
        login( this.email, this.password )
          .then( response => {
            this.submitting = false;

            if ( response.data ) {
              if ( response.data.webAccountId ) {
                this.submitted = true;
                this.hasError = false;
                this.errorMessage = null;

                if ( this.redirect ) {
                  window.location = this.redirectUrl;
                }

                this.$emit( "loggedIn" );
              } else {
                console.log( `Error code - ${response.data.errorCode}, Message - ${response.data.errorMessage}` );
                this.submitted = false;
                this.hasError = true;
                if ( response.data.errorCode === 105 || response.data.errorCode === 106 ) {
                  this.errorMessage = "Invalid username/password. Please try again";
                } else {
                  this.errorMessage = response.data.errorMessage;
                }
              }
            } else {
              this.hasError = false;
            }
          } )
          .catch( error => {
            console.log( `Error - ${error}` );
            this.hasError = true;
            this.errorMessage = "Unknown error has occurred";
            this.submitted = false;
            this.submitting = false;
          } );
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .capslock-warning {
    color: #555;
    font-size: 14px;
    padding-top: 5px;
  }

  .btn {
    min-width: 130px;
  }

  .alert {
    max-width: 400px;
  }
</style>
